<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Order Number Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('OTHER_SERVICE.order_number')"
                v-model.trim="filterOptions.order_number"
              />
              <!-- End:: Order Number Input -->

              <!-- Start:: Status Input -->
              <base-select-input
                col="4"
                :optionsList="statusArray"
                :placeholder="$t('OTHER_SERVICE.order_status')"
                v-model="filterOptions.status"
              />
              <!-- End:: Status Input -->

              <!-- Start:: Customer Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('OTHER_SERVICE.customer_name')"
                v-model="filterOptions.user_name"
              />
              <!-- End:: Customer Name Input -->

              <!-- Start:: Cart Owner Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('OTHER_SERVICE.cart_owner_name')"
                v-model.trim="filterOptions.provider_name"
              />
              <!-- End:: Cart Owner Name Input -->

              <!-- Start:: Date From Input -->
              <base-input
                col="4"
                type="date"
                :placeholder="$t('OTHER_SERVICE.date_from')"
                v-model="filterOptions.date_from"
              />
              <!-- End:: Date From Input -->

              <!-- Start:: Date To Input -->
              <base-input
                col="4"
                type="date"
                :placeholder="$t('OTHER_SERVICE.date_to')"
                v-model="filterOptions.date_to"
              />
              <!-- End:: Date To Input -->
            </div>

            <div class="btns_wrapper">
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.search") }}</span>
                </template>
                <span
                  class="submit_btn"
                  @click="submitFilterForm"
                  :disabled="isWaitingRequest"
                >
                  <i class="fal fa-search"></i>
                </span>
              </a-tooltip>

              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.rseet_search") }}</span>
                </template>
                <span
                  class="reset_btn"
                  :disabled="isWaitingRequest"
                  @click="resetFilter"
                >
                  <i class="fal fa-redo"></i>
                </span>
              </a-tooltip>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("OTHER_SERVICE.title") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
        <div class="title_route_wrapper">
          <a :href="exportUrl" target="_blank" class="export_btn" download>
            <i class="fal fa-file-excel"></i>
            {{ $t("BUTTONS.export_excel") }}
          </a>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->

        <!-- Start:: Serial Number -->
        <template v-slot:[`item.id`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <p v-else>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>
        <!-- End:: Serial Number -->
        <template v-slot:[`item.order_num`]="{ item }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id"
            >-</p
          >
          <p v-else>{{ item.id }}</p>
        
        </template>
        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AllOtherService",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Export URL
      exportUrl: null,
      // End:: Export URL

      // Start:: Status Array
      statusArray: [
        {
          id: "NEW",
          name: this.$t("OTHER_SERVICE_STATUS.new"),
          value: "new",
        },
        {
          id: "ACCEPTED",
          name: this.$t("OTHER_SERVICE_STATUS.accepted"),
          value: "accepted",
        },
        {
          id: "REJECTED",
          name: this.$t("OTHER_SERVICE_STATUS.rejected"),
          value: "rejected",
        },
        {
          id: "IN_DELIVERY",
          name: this.$t("OTHER_SERVICE_STATUS.in_delivery"),
          value: "in_progress",
        },
        {
          id: "COMPLETED",
          name: this.$t("OTHER_SERVICE_STATUS.completed"),
          value: "completed",
        },
        {
          id: "CANCELED",
          name: this.$t("OTHER_SERVICE_STATUS.canceled"),
          value: "canceled",
        },
      ],
      // End:: Status Array

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        order_number: null,
        status: null,
        user_name: null,
        provider_name: null,
        date_from: null,
        date_to: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("OTHER_SERVICE.serial_number"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.order_number"),
          value: "order_num",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.order_date"),
          value: "created_at",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.order_status"),
          value: "status_label",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.customer_name"),
          value: "user_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.cart_owner_name"),
          value: "provider_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.order_price"),
          value: "price",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.pickup_location"),
          value: "pickup_location",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("OTHER_SERVICE.drop_location"),
          value: "drop_location",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Clients.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/carrier-service/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.order_number = null;
      this.filterOptions.status = null;
      this.filterOptions.user_name = null;
      this.filterOptions.provider_name = null;
      this.filterOptions.date_from = null;
      this.filterOptions.date_to = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/carrier-service/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "orders",
          params: {
            type: "carrier_service",
            page: this.paginations.current_page,
            id: this.filterOptions.order_number,
            status: this.filterOptions.status?.value,
            user_name: this.filterOptions.user_name,
            provider_name: this.filterOptions.provider_name,
            created_at_from: this.filterOptions.date_from,
            created_at_to: this.filterOptions.date_to,
          },
        });
        this.loading = false;

        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta?.last_page || 1;
        this.paginations.items_per_page = res.data.data.meta?.per_page || 10;
        this.exportUrl = res.data.data.export_url || null;
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$message.error(
          error.response?.data?.message || "Error loading data"
        );
      }
    },
    // End:: Set Table Rows

    // ==================== Start:: Crud ====================
    // ===== Start:: Show
    showItem(item) {
      this.$router.push({ path: `/carrier-service/show/${item.id}` });
    },
    // ===== End:: Show

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
span.submit_btn,
a.export_btn {
  width: 45px;
  height: 45px;
  font-size: 16px;
  border-radius: 10px;
  color: var(--white_clr);
  transition: all 0.3s linear;
  background-color: #f6a513;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
}

span.reset_btn {
  width: 45px;
  height: 45px;
  font-size: 16px;
  border-radius: 10px;
  color: var(--white_clr);
  transition: all 0.3s linear;
  background-color: #dc3545;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

a.export_btn {
  background-color: #28a745;
  margin-left: 10px;
}
</style>
